<template>
  <div>
    <v-row :style="addCampaignClass">
      <v-col cols="12" md="6" class="text-right py-0">
        <gg-btn color="primary" tile @click="openAddCampaign">
          Add Campaign
        </gg-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <gg-card>
          <gg-card-header>
            Affiliate Campaign Instructions
          </gg-card-header>
          <gg-card-text>
            <div>
              <v-row>
                <v-col cols="12">
                  <p>
                    Campaigns will allow you to create unique codes that you can use to identify specific marketing
                    initatives, sites or projects to allow you to convert better.
                  </p>
                  <span>
                    Click the link below to Add a Campaign Code.
                  </span>
                </v-col>
                <v-col cols="12" md="6" class="pb-0">
                  <h4>Your Campaigns</h4>
                </v-col>
                <v-col cols="12">
                  <gg-text-field
                    v-model="search"
                    hide-details
                    placeholder="Search"
                  />
                </v-col>
                <v-col cols="12">
                  <v-data-table :headers="headers"
                                :items="campaigns"
                                :search="search"
                                :loading="pending"
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <gg-btn color="primary" icon  v-bind="attrs" v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                          </gg-btn>
                        </template>
                        <v-list>
                          <v-list-item @click="triggerEditDescription(item)">
                            <v-list-item-title>
                              Edit
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </div>
          </gg-card-text>
        </gg-card>
      </v-col>
    </v-row>

    <gg-modal :is-active="addDialog" @close="closeAddCampaign">
      <template v-slot:toolbar>
        Create Campaign
      </template>
      <template v-slot:body>
        <p>To create your campaign codes, simply enter an alpha-numeric code (no special characters allowed) in the
          Campaign Code field.</p>

        You will also be able to enter a description to help you identify your campaigns later on. Once you're
        satisfied, click on <b>Save Changes</b>.
        <v-row>
          <v-col cols="12" sm="4">
            <gg-text-field v-model="model.add.campaign_code"
                           label="Campaign Code"
                           data-vv-name="campaign_code"
                           data-vv-as="Campaign Code"
                           v-validate="'required'"
                           :error-messages="errors.collect('campaign_code')"
            />
          </v-col>
          <v-col cols="12" sm="8">
            <gg-text-field v-model="model.add.campaign_description"
                           label="Description"
            />
          </v-col>
        </v-row>
      </template>
      <template v-slot:actions>
        <gg-btn secondary @click="closeAddCampaign">Close</gg-btn>
        <gg-btn primary :loading="newCampaignPending" @click="addCampaign">Save Changes</gg-btn>
      </template>
    </gg-modal>
    <gg-modal :is-active="editDialog" @close="triggerEditDescription">
      <template v-slot:toolbar>
        Edit Campaign Description
      </template>
      <template v-slot:body>
        <p>
          Edit campaign description
        </p>
        <v-row>
          <v-col cols="12">
            <gg-text-field v-model="model.edit.value"
                           label="Description"
            />
          </v-col>
        </v-row>
      </template>
      <template v-slot:actions>
        <gg-btn secondary @click="triggerEditDescription">Close</gg-btn>
        <gg-btn primary :loading="editPending" @click="editDescription">Save Changes</gg-btn>
      </template>
    </gg-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AffiliatesCampaigns',
  data: () => ({
    pending: false,
    newCampaignPending: false,
    editPending: false,
    search: '',
    headers: [
      { text: 'Date Created', value: 'created_at' },
      { text: 'Campaign Code', value: 'code' },
      { text: 'Description', value: 'description' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    addDialog: false,
    editDialog: false,
    model: {
      add: {
        campaign_code: '',
        campaign_description: ''
      },
      edit: {
        name: 'description',
        value: '',
        pk: ''
      }
    }
  }),
  created () {
    this.getCampaigns()
  },
  computed: {
    ...mapGetters({
      campaigns: 'affiliates/campaigns'
    }),
    addCampaignClass () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return {
            position: 'absolute',
            top: '85px',
            right: '10px',
          }
        case 'sm':
          return {
            position: 'absolute',
            top: '85px',
            right: '10px',
          }
        case 'md':
          return {
            position: 'absolute',
            top: '85px',
            right: '60px',
          }
        default:
          return {
            position: 'absolute',
            top: '85px',
            right: '60px',
          }
      }
    },
  },
  methods: {
    ...mapActions({
      affCampaigns: 'affiliates/affCampaigns',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError'
    }),
    async getCampaigns () {
      try {
        this.pending = true
        await this.affCampaigns({ action: 'campaign_codes' })
      } catch (e) {
        this.reportError(e)
      } finally {
        this.pending = false
      }
    },
    async addCampaign () {
      try {
        const valid = await this.$validator.validateAll()
        if (!valid) {
          return
        }
        this.newCampaignPending = true

        const { resultmsg } = await this.affCampaigns({
          ...this.model.add,
          action: 'add_campaign_code'
        })
        this.closeAddCampaign()
        await this.getCampaigns()
        this.reportSuccess(resultmsg)
      } catch (e) {
        this.reportError(e)
      } finally {
        this.newCampaignPending = false
      }
    },
    async editDescription () {
      try {
        this.editPending = true

        const { resultmsg } = await this.affCampaigns({
          ...this.model.edit,
          action: 'update_description'
        })
        this.triggerEditDescription()
        await this.getCampaigns()
        this.reportSuccess(resultmsg)
      } catch (e) {
        this.reportError(e)
      } finally {
        this.editPending = false
      }
    },
    openAddCampaign () {
      this.addDialog = true
    },
    triggerEditDescription (item = {}) {
      this.model.edit.value = item.description === undefined ? '' : item.description
      this.model.edit.pk = item.id === undefined ? '' : item.id
      this.editDialog = !this.editDialog
    },
    closeAddCampaign () {
      this.addDialog = false
      this.model.add.campaign_code = ''
      this.model.add.campaign_description = ''
    },
  },
}
</script>
